import Button from '@shared/components/Button/Button';

import { ReactComponent as Pencil } from 'assets/icons/Pencil.svg';

import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';
import { CreateNewRoomStepsEnum } from '../utils';

interface EditButtonProps {
  step: CreateNewRoomStepsEnum;
}

const EditButton = ({ step }: EditButtonProps) => {
  const { setCurrentStep, setHasToReturnToReview } = useCreateNewRoomDataContext();

  const handleClick = () => {
    setHasToReturnToReview(true);
    setCurrentStep(step);
  };

  return (
    <Button variant="buttonIconGhost" size="neutral" className="!rounded-xl p-1 ml-2" onClick={handleClick}>
      <Pencil className="stroke-primary-50 h-6 w-6 shrink-0 stroke-1.5" />
    </Button>
  );
};

export default EditButton;
